import { getAuth } from 'util/auth';

export default getAuth;

export const selectorIsMemberOfGroup = (state, id) =>
  state.authToken.groups.find((group) => group.id === id) !== undefined;
